import { AutomatedAuditLoader, Button, Select, TextInput } from '@common/components';
import { useForm } from '@mantine/form';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { checkValidHttps } from '@common/helpers/checkValidHttps';
import { FC, useEffect, useState } from 'react';
import { Flex, Space } from '@mantine/core';
import { addClientOrganization, getOwnCompanies, inviteCompanyToOrganization, inviteCompanyToOrganizationError, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { validateUserIdentifier } from 'src/helpers/organization';
import { useAlert, useFormFocus } from '@common/hooks';
import { Label } from 'reactstrap';

interface Props {
  onCloseFun: () => void;
}

const InviteCompany: FC<Props> = ({ onCloseFun }) => {
  const [t] = useTranslation('organization');
  const [c] = useTranslation('account');
  const { showAlert } = useAlert();
  const { loadingClientJoinOrganization, getOwnCompaniesdata } = useAppSelector((state) => state.organization, shallowEqual);
  const { company_id } = useAppSelector((state) => state.user.data, shallowEqual);
  const [companiesList, setCompaniesList] = useState([])
  const dispatch = useAppDispatch();


  type formValue = {
    user_email: string,
    company_id: string
  }
  const form = useForm({
    initialValues: {
      user_email: '',
      company_id: company_id ?? ""
    },

    validate: {
      user_email: (value) => {
        const notValid = validateUserIdentifier(value, 'Email')
        if (notValid) {
          setNeedFocus(true)
          return 'Please enter a valid email address';
        }
        return notValid
      },

      company_id: (value) => {
        if (!value) {
          return 'Please select a company'
        }
      }
    },
  });
  const { setNeedFocus } = useFormFocus({ formErrors: form.errors });

  const handleInviteCompanyToOrganisation = async ({ user_email, company_id }: formValue) => {
    dispatch(inviteCompanyToOrganization({
      user_email: user_email,
      company_id,
      submitCallback: () => {
        showAlert({
          id: 'userAdded' + user_email,
          title: `Invite New User.`,
          message: `User Invitation has been sent to ${user_email}. Waiting for Approval`,
          variant: 'success',
          autoClose: 3000
        });

        onCloseFun()
      },
      errorCallback: (error: string) => {

        setNeedFocus(true);
        showAlert({
          id: error,
          title: 'Invite New User.',
          message: `Enable to send Invite to ${user_email} Please Try Later.`,
          variant: 'error',
          autoClose: 3000
        });
        form.setFieldError('user_email', `Enable to send Invite to ${user_email} Please Try Later.`)
      }
    }))
  }

  useEffect(() => {
    if (form?.errors?.user_email) {
      const errorMessage = document.querySelector('.mantine-InputWrapper-error');
      if (errorMessage) {
        errorMessage.role = 'status'
        errorMessage.ariaLive = 'polite'
        errorMessage.ariaAtomic = 'true'
      }
    }
  }, [form?.errors?.user_email]);

  useEffect(() => {
    if (!getOwnCompaniesdata) {
      dispatch(getOwnCompanies());
    }

    if (getOwnCompaniesdata) {
      const data = getOwnCompaniesdata?.map((company: any) => ({ label: company.company_name, value: company?.id }))

      setCompaniesList(data)
    }
  }, [getOwnCompaniesdata])
  return (
    <div className={styles.warraper}>
      <form
        className={classNames(styles['form-container'])}
        aria-invalid={form.errors.user_email ? 'true' : 'false'}
        onSubmit={form.onSubmit((values) => {
          handleInviteCompanyToOrganisation({
            user_email: values?.user_email,
            company_id: values.company_id
          })
        })}>
        <TextInput
          autoFocus
          className={classNames(styles['grow'])}
          label={`${c('notificationTab.inviteCompany.title')}`}
          placeholder={`${c('notificationTab.inviteCompany.placeHolder')}`}
          {...form.getInputProps('user_email')}
        />
        <Space h={"md"} />
        <Select
          width='100%'
          maxWidth="100%"
          variant="secondary"
          sx={{
            '.mantine-Select-dropdown': {
              width: '350px !important',
            },
          }}
          label='Company'
          withIcon
          data={companiesList ?? []}
          {...form.getInputProps('company_id')}
        />
        <Space h={"md"} />
        <Flex gap={"md"} mt={'md'} justify={"end"} >
          <Button type={'submit'}
            loading={loadingClientJoinOrganization}
            ariaLabel={`Send invite to the specified user`}
          >
            Send invite

            {
              loadingClientJoinOrganization && <AutomatedAuditLoader />
            }
          </Button>
          <Button
            ariaLabel='Cancel user invitation'
            color={'dark-green'}
            onClick={() => {
              form.reset();
              onCloseFun();
            }}>
            {t('addOrganization.cancelbtn')}
          </Button>
        </Flex>

      </form>
    </div>
  );
};

export default InviteCompany;
